import { render } from "./ShareButton.vue?vue&type=template&id=b5b05bf6&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"

import "./ShareButton.vue?vue&type=style&index=0&id=b5b05bf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b05bf6"]])

export default __exports__